import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const LoadingOrUnloadingPointsPageContent = lazy(() => import("./LoadingOrUnloadingPointsPageContent"));

function LoadingOrUnloadingPointsPageInternal() {
    return (
        <DefaultPage>
            <LoadingOrUnloadingPointsPageContent />
        </DefaultPage>
    );
}

export const LoadingOrUnloadingPointsPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER)
)(LoadingOrUnloadingPointsPageInternal);
